/* jshint esnext: true */
import Form from './Form';
import Dropdown from './Dropdown';

import {scrollTo} from '../global/scrollTo';

import tap from '../ractive/ractive-events-tap';
import slide from '../ractive/ractive-transitions-slide';

import {unescapeHtml} from '../utils/html';
import {arrayContains} from '../utils/array';

export default class extends Form {
    constructor(options) {
        super(options);
        this.dropdown   = null;
        this.controller = this.initController();
        this.checkSuccess()
    }

    checkSuccess() {
        let params = App.queryParams();

        if (params['form-id'] === 'job-form') {
            $('#toggle_tab_form').tab('show');
            scrollTo($('.js-content-start'));
            $('.js-pre-submit').hide();

            if (params['success'] === 'true') {
                $('.js-post-submit').show();
            } else {
                $('.js-post-submit-error').show();
            }
        }
    }

    initController() {
        var _this      = this;
        var controller = new Ractive({
            el              : this.$el,
            delimiters      : ['[[', ']]'],
            tripleDelimiters: ['[[[', ']]]'],
            template        : unescapeHtml(this.$el.html()),
            data            : {
                department              : [],
                displayExtraInfo        : false,
                displayOtherDepartment  : false,
                jobs                    : window.templateData.jobs,
                selectedJob             : '',
                alreadyWorked           : '',
                displayOldJob           : false,
                validCards              : '',
                displayValidCardsPrecise: false,
                jobReferrer             : '',
                displayJobReferrerOther : false,
                displayJobReferrer      : false,
            },
            computed        : {},
            events          : {tap},
            transitions     : {slide},
            /**
             * Allows us to set proxy events and run other tasks when controller is initialized
             * @param  {array}  options  Array of options
             */
            oninit          : function (options) {
                this.on({
                    applyToJob: function (event) {
                        this.set('selectedJob', this.get(event.keypath).ident);
                        $('#toggle_tab_form').tab('show');
                        scrollTo($('.js-content-start'));
                    }
                });
            }
        });

        controller.observe('selectedJob', (newValue) => {
            controller.set('displayExtraInfo', (newValue === 'spontaneous'));
            _this.resetForm();
        });

        controller.observe('selectedJob', (newValue) => {
            controller.set('displayJobReferrer', (newValue !== 'spontaneous' && newValue !== ''));
            _this.resetForm();
        });

        controller.observe('department', (newValue) => {
            if (arrayContains(newValue, 'other') && controller.get('displayExtraInfo')) {
                controller.set('displayOtherDepartment', true).then(() => {
                    $('#otherDepartment').focus();
                    _this.resetForm();
                });
            } else {
                controller.set('displayOtherDepartment', false);
                _this.resetForm();
            }
        });

        controller.observe('alreadyWorked', (newValue) => {
            controller.set('displayOldJob', (newValue === 'true'));
            _this.resetForm();
        });

        controller.observe('validCards', (newValue) => {
            controller.set('displayValidCardsPrecise', (newValue === 'true'));
            _this.resetForm();
        });

        controller.observe('jobReferrer', (newValue) => {
            controller.set('displayJobReferrerOther', (newValue === 'other'));
            _this.resetForm();
        });

        // Store them jQuery elems
        _this.resetForm();

        // Constructing the Dropdown behaviour here since
        // it would get gobbled up by Ractive
        _this.dropdown = new Dropdown({
            $el                : this.$el,
            el                 : this.el,
            'dropdown-mode'    : 'accordion',
            'dropdown-scrollto': true
        });

        return controller;
    }

    resetForm() {
        this.$el.off('.Form');
        this.initForm();
    }

    destroy() {
        this.controller.teardown();
        this.dropdown.destroy();
        this.$el.off('.JobForm');
    }
}
